/* This is generated code, don't alter */
var IfcFilterTypeEnum;
(function (IfcFilterTypeEnum) {
    IfcFilterTypeEnum[IfcFilterTypeEnum["AIRPARTICLEFILTER"] = 0] = "AIRPARTICLEFILTER";
    IfcFilterTypeEnum[IfcFilterTypeEnum["COMPRESSEDAIRFILTER"] = 1] = "COMPRESSEDAIRFILTER";
    IfcFilterTypeEnum[IfcFilterTypeEnum["ODORFILTER"] = 2] = "ODORFILTER";
    IfcFilterTypeEnum[IfcFilterTypeEnum["OILFILTER"] = 3] = "OILFILTER";
    IfcFilterTypeEnum[IfcFilterTypeEnum["STRAINER"] = 4] = "STRAINER";
    IfcFilterTypeEnum[IfcFilterTypeEnum["WATERFILTER"] = 5] = "WATERFILTER";
    IfcFilterTypeEnum[IfcFilterTypeEnum["USERDEFINED"] = 6] = "USERDEFINED";
    IfcFilterTypeEnum[IfcFilterTypeEnum["NOTDEFINED"] = 7] = "NOTDEFINED";
})(IfcFilterTypeEnum || (IfcFilterTypeEnum = {}));
const IfcFilterTypeEnumCount = 8;
export { IfcFilterTypeEnum, IfcFilterTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcFilterTypeEnum = new Int32Array([1, 1, 54]);
let prefixSumAddressIfcFilterTypeEnum = new Uint32Array([0, 21, 40, 52, 62, 74, 87, 100, 111]);
let slotMapIfcFilterTypeEnum = new Int32Array([1, 0, 7, 4, 2, 5, 6, 3]);
let encodedDataIfcFilterTypeEnum = (new TextEncoder()).encode(".COMPRESSEDAIRFILTER..AIRPARTICLEFILTER..NOTDEFINED..STRAINER..ODORFILTER..WATERFILTER..USERDEFINED..OILFILTER.");
let IfcFilterTypeEnumSearch = new MinimalPerfectHash(gMapIfcFilterTypeEnum, prefixSumAddressIfcFilterTypeEnum, slotMapIfcFilterTypeEnum, encodedDataIfcFilterTypeEnum);
export { IfcFilterTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcFilterTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcFilterTypeEnumSearch, input, cursor, endCursor);
}
